const header = document.querySelector("header")

if (header) {
    desktopScrollInteraction = () => {
        const body = document.body;
        const headerTop = document.querySelector('.header__top');
        const headerBottom = document.querySelector('.header__bottom');
        const headerTopHeight = headerTop.clientHeight;
        const headerBottomHeight = headerBottom.clientHeight;

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 40)) {
            body.classList.add('header-fixed');
        } else {
            body.classList.remove('header-fixed');
        }

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 100)) {
            body.classList.add('transitions-on');
        } else {
            body.classList.remove('transitions-on');
        }

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 450)) {
            headerBottom.classList.add('active');
        } else {
            headerBottom.classList.remove('active');
        }
    };

    window.addEventListener("scroll", () => {
        desktopScrollInteraction()
    })
}